
import { onMounted, reactive, computed } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'MypageLeaveInput',

  props: {
    answer: Number,
    answer_comment: String
  },

  components: {
    Button,
    HeadingLv1,
  },
  setup(props: any, context: any) {

    const store = useStore()
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    interface SelectObject {
      label: string,
      value: string,
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '0',
      selected: false
    }

    const reasons: Array<SelectObject> = reactive([selectDefault])

    const select = reactive({
      value : 0
    })

    const confirm = () => {
      router.push('/mypage/leave/confirm');
    }

    const updateAnswer = ($event:any) => {
      context.emit('update:answer', $event)
      context.emit('update:answer_comment', reasons[$event].label)
      select.value = $event
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      getList
        .get('/api/v1/user_leave/unsub_reason')
        .then((res) => {
          res.data.forEach((el: any) => {
            if (el.opt_id != 0) {
              const item: SelectObject = {
                label: el.option_name,
                value: el.opt_id,
                selected: false,
              }
              reasons.push(item)
            }
          })
        })
        .catch(() => {
          state.isLoading = false
        })
    })

    const isDisabledNextBtn = computed(() => {
      console.log("computed", select.value);
      if (select.value >= 1) {
        return false;
      }
      return true;
      /*if (
        (this.a == null || this.a == 0)
      ) {
        return true
      }

      return false*/
    })

    return {
      state,
      FormSelectField,
      confirm,
      reasons,
      updateAnswer,
      isDisabledNextBtn
    }
  }
}
